import React from "react"
import Grid from '@material-ui/core/Grid';

/* importing custom modules */
import StaticExpander from '../components/Material-UI-Components/StaticExpander.js';
import Layout from '../components/layout'
import ContactForm from '../components/Custom Modules/ContactForm';
import SEO from "../components/seo"

/* importing json files */
import FamilyRelationship from '../components/Page-Data/FamilyRelationship.json';

/* importing images */
import Logo from '../images/Relationship/logo.png';

const RelationshipFamilyCounseling = () => (
  <Layout>
    <SEO 
      title="Relationship and Family Counselling, Marriage Counsellors in India at Pratiiti.com" 
      description="Relationship and Family Counselling-Pratiiti.com provide you qualified counsellors for Relationship and Family counselling at affordable rates."
      canonical={"https://www.pratiiti.in/relationship-family-counselling"}
    />
    <div>
    <Grid xs={12} md={6} sm={3}>
      <div className="logo">
        <img src={Logo} alt="Relationship and Family Counselling"/>
      </div>
    </Grid>
      <StaticExpander
        data = {FamilyRelationship}
      />
	  </div>
    <ContactForm/>
  </Layout>
)

export default RelationshipFamilyCounseling
